import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiVisa, BaseApiTemplateService, Core2Config } from "../../shared";
import { FiItemBranchLinkImportFileHdrContainer } from '../../../../../../models';

@Injectable({
  providedIn: 'root'
})
export class FiItemBranchLinkDataService extends BaseApiTemplateService<FiItemBranchLinkImportFileHdrContainer> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'item-branch-link-import-file-hdrs';
  
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'item-branch-link-import-file-hdrs';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'item-branch-link-import-file-hdrs';
    this.httpClient = http;
  }

  async fiItemBranchLinkDownloadCSV(authorization: string, apiVisa: ApiVisa) {
    const CSV_URL = apiVisa.api_domain_url + this.endpoint_path + '/backoffice-ep/download-master-data-template';
    const headers = new HttpHeaders({ "authorization": authorization, "tenantCode": apiVisa.tenantCode });
    const fileBlob = await this.httpClient
        .get(CSV_URL, { headers, responseType: 'blob' })
        .toPromise();
    return fileBlob;
  }
}